import React, {useContext, useState, useEffect} from 'react';
import SignaturePad from "../CommonComponents/SignaturePad";
import PayDepositForm from "./PayDepositForm"
import BookMoveDate from "../CommonComponents/BookMOveDate"
import DeclineEstimate from "../CommonComponents/DeclineEstimate"
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {Elink, CreateEstimateDuplicate, EditCurrentEstimate, PrintClientPortalPdf} from "../CommonComponents/Routes";
import parse from "html-react-parser";
import './Inventory.css'
import axios from "axios";
import {Modal} from "react-bootstrap";
import InvoicePaymentForm from "./InvoicePaymentForm";
import TipModal from "./TipModal";

export default () => {
    let Record = useContext(RecordsManagementContext)
    let EstimateAndCompanyInfoData = Record.CP_PageDetails.EstimateAndCompanyInfo
    let Estimate = EstimateAndCompanyInfoData.Estimate
    let IV1_PageDetails = Estimate.EstimateServiceDate
    let InputFields = Record.CP_PageDetails.ClientPortalHeader.PortalPayment.InputFields
    let buttoncolor = Record.CP_PageDetails.ClientPortalHeader.ButtonColor
    let data = Record.CP_PageDetails.EstimateDetails.JobDetails
    data = data.JobDetails == undefined ? data : data.JobDetails
    let IsJobOpen = Record.IsJobOpen
    let ClientPortalHeader = Record.CP_PageDetails.ClientPortalHeader
    let modalHide = Record.modal
    let PageView = useContext(ViewMangementContext)
    let InvoiceType = PageView.InvoiceType
    let body = data.CustomerPortalPopupBody
    body = parse(`${body}`)
    let ShowClientPortalPopup = data.ShowClientPortalPopup
    let DeclinedEvent = data.DeclinedEvent
    let ShowAddendumButton = data.ShowEstimateAddendumButton
    let estimate_addendums = data.EstimateAddendum
    let isDeclined = data.is_declined
    const [modal, setModal] = useState(true)
    const [Disabled, setDisabled] = useState(false)

    useEffect(() => {
        if (modalHide && ShowClientPortalPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [modalHide, ShowClientPortalPopup]);

    // make the scroll bar stick to the page even when scroll the page down it will always visible on the page.
    window.addEventListener('scroll', function () {
        let body = document.getElementById('scroll_navbar');
        if (body) {
            if (window.scrollY > 0) {
                body.setAttribute('style', 'border-bottom: 1px solid #26a9e0');
                body.setAttribute('style', 'box-shadow:  0 2px 0 0 #26a9e0');
            } else {
                body.removeAttribute('style', 'border-bottom');
            }
        }
    })
    // Function to calculate luminance from RGB color
    const calculateLuminance = (backgroundColor) => {
        if (backgroundColor === "#ffffff") return 'black';
        if (backgroundColor === "#000000") return 'white';
        const hexToRgb = (hex) => {
            let r = parseInt(hex.slice(1, 3), 16);
            let g = parseInt(hex.slice(3, 5), 16);
            let b = parseInt(hex.slice(5, 7), 16);
            return {r, g, b};
        };
        const rgb = hexToRgb(backgroundColor);
        const luminance = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
        return luminance > 220 ? 'black' : 'white';
    };

    const Button = (props) => {
        const buttonStyles = props.Style || {};
        if (props.Show) {
            return (
                <div className={props.ClsName} style={buttonStyles}
                     onClick={() => OpenModal(props.For)}>
                    {props.For}
                </div>
            )
        } else {
            return (<></>)
        }
    }
    const handleModal = () => {
        Record.setPaymentModal(false) //close pay deposit modal
    }

    const hideInvoicePaymentModal = () => {
        Record.setInvoicePaymentModal(false) //close pay deposit modal
    }

    const OpenModal = async (FOR) => {
        if (FOR === "PAY DEPOSIT") {
            Record.setPaymentModal(true) // set value true so that Pay deposit modal is visible on the page.
        } else if (FOR === "SIGN ESTIMATE") {
            Record.setSignModal(true) // set value true so that Sign estimate modal will open on the page.
        } else if (FOR === 'PAY MY INVOICE') {
            if (checkTipAmount()){
                Record.setCrewTipModal(true)
                Record.setTipforCrew(false)
            }else{
                Record.setInvoicePaymentModal(true)}
        }
    }

    const openModal = () => {
        let DeclineEstimateContent = { // set DeclineEstimate modal content
            Title: 'Not interested',
            Body: <DeclineEstimate/>,
            Class: 'decline_estimate_modal'
        }
        PageView.setModalContent(DeclineEstimateContent)
    }

    const checkTipAmount = () => {
        if(Record.IV2_PageDetails.JobDetails.Tip.Value !== undefined) {
            if (Record.IV2_PageDetails.JobDetails.Tip.Value <= 0 && Record.Tip == '' && ClientPortalHeader.InvoicePayment.IsBilledJob) {
                return true;
            } else {
                return false;
            }
        }else if(Record.IV1_PageDetails.Tip !== undefined){
            if (Record.IV1_PageDetails.Tip <= 0 && Record.Tip == '' && ClientPortalHeader.InvoicePayment.IsBilledJob) {
                return true;
            } else {
                return false;
            }
        }
    }

    const requestMoveDate = () => {// set request move date modal content
        let MoveDate = {
            Title: 'Request Move Date',
            Body: <BookMoveDate/>,
            Class: 'book_move_modal'
        }
        PageView.setModalContent(MoveDate)
    }

    const handleShow = () => {
        Record.setModal(false) //close the modal
    }
    const handleModal2 = () => {
        Record.setSignModal(false) //close the signature modal
    }

    const printClientPortal = async () => { // Function to print Client Portal in Pdf Format & DownLoad it.
        let Url = `${ClientPortalHeader.PrintPortal.url}/print_estimate_by_client?id=${ClientPortalHeader.PrintPortal.estimate_id}`
        window.open(Url)
    }
    const show_estimate_addendum = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const disblebutton = selectedOption.getAttribute('data-disblebutton');
        const showUnsubmitButton = selectedOption.getAttribute('data-showUnsubmit');
        Record.setSelectedAddendum(e.target.value);
        Record.setDisblebutton(disblebutton);
        Record.setUnsubmitbutton(showUnsubmitButton);
        PageView.Set('SHOW ESTIMATE ADDENDUM');
    }

    return (
        <div className="estimate-wrap scroll_navbar" id="scroll_navbar">
            <div style={{overflowY: 'scroll'}} className={"advertiseModal modal fade" +
                (modalHide && ShowClientPortalPopup ? " show d-block " : " d-none ")} tabIndex="-1" role="dialog">
                <div style={{width: "fit-content", maxWidth: 'none'}} className="modal-dialog" role="document">
                    <div style={{width: "auto", minWidth: "300px", aboxShadow: "1px 3px 1px #9E9E9E"}}
                         className="modal-content">
                        <div className="modal-header" style={{border: "none"}}>
                        </div>
                        <div className="advertiseBody"
                             style={{objectFit: 'cover', maxWidth: '100%', padding: "10px", overflow: "overlay"}}>
                            {body}
                        </div>
                        <div>
                            <button type="button" className="advertiseClose" onClick={() => handleShow()}
                                    style={{width: 60, borderWidth: 'thin', borderRadius: 5}}> Close
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            <div className="container">
                <div className="estimate-number">
                    <div className="top-estimate d-flex justify-content-between align-items-center">
                        <div className="ph-number-wp">
                            <div className="ph-number">
                                <img src={process.env.PUBLIC_URL + "Images/phone.png"} alt="Phone Icon"/>
                            </div>
                            <div className="ph-contact">
                                <p className="mb-0 text-muted">Call us anytime</p>
                                <h6>{ClientPortalHeader.CompanyBranchPhnNumber}</h6>
                                <h6>{ClientPortalHeader.CompanyBranchTollFree}</h6>
                            </div>
                        </div>
                        {data.IsScheduled ?
                            <div className="text-start" style={{paddingRight: IsJobOpen ? "12%" : "0%"}}>
                                <b>This Estimate is Booked For - {IV1_PageDetails}</b>
                            </div>
                            :
                            <>
                                {Estimate.CancelJob ?
                                    <div className="text-start" style={{paddingRight: IsJobOpen ? "12%" : "0%"}}>
                                        <b>This Estimate is Cancelled</b></div>
                                    :
                                    <>
                                        {DeclinedEvent ?
                                            <div className="text-start"
                                                 style={{paddingRight: IsJobOpen ? "12%" : "0%"}}>
                                                <b>This Estimate is Declined</b></div> : ""}
                                    </>
                                }
                            </>
                        }
                        <div className="print-btns">
                            {ShowAddendumButton && (
                                <select
                                    className="custom-select addendum-select-1 styled-select"
                                    defaultValue="" onChange={(e) =>show_estimate_addendum(e)}
                                >
                                    <option value="" disabled>Addendum</option>
                                    {Object.keys(estimate_addendums).map((addendum_name, key) => (
                                        <option
                                            key={key + "addendum_name"}
                                            value={estimate_addendums[addendum_name].id}
                                            data-disblebutton={estimate_addendums[addendum_name].disblebutton}
                                                data-showUnsubmit = {estimate_addendums[addendum_name].showUnsubmitButton}
                                        >
                                            {estimate_addendums[addendum_name].name}
                                        </option>
                                    ))}
                                </select>
                            )}
                            {DeclinedEvent ?
                                <></>
                                :
                                <>
                                    {data.IsScheduled || Estimate.CancelJob ?
                                        <></> :
                                        <>
                                            <div
                                                style={{
                                                    display: isDeclined ? 'block' : 'none',
                                                    background: buttoncolor.declineestimate,
                                                    color: calculateLuminance(buttoncolor.declineestimate),
                                                    border: `1px solid ${buttoncolor.declineestimate}`
                                                }}
                                                className="btn-right d-flex"
                                                onClick={() => openModal()}
                                                data-toggle="modal"
                                                data-target="#Modal">
                                                DECLINE ESTIMATE
                                            </div>
                                            {ClientPortalHeader.RequestMoveDate === true && Record.RequestMoveDateShown ?
                                                <div style={{
                                                    background: buttoncolor.requestdate,
                                                    color: calculateLuminance(buttoncolor.requestdate),
                                                    border: `1px solid ${buttoncolor.requestdate}`
                                                }} className="btn-right d-flex" data-toggle="modal"
                                                     data-target="#Modal"
                                                     onClick={() => requestMoveDate()}>REQUEST MOVE DATE</div> : <></>

                                            }
                                        </>

                                    }
                                </>
                            }

                            <Button Style={{
                                background: buttoncolor.paydeposit,
                                color: calculateLuminance(buttoncolor.paydeposit),
                                border: `1px solid ${buttoncolor.paydeposit}`
                            }}
                                    ClsName="btn-right d-flex"
                                    Show={(ClientPortalHeader.PortalPayment.IsDeposit)}
                                    ClassName="btn-right bg-brd" For='PAY DEPOSIT'/>
                            <Button
                                ClsName="btn-right d-flex"
                                Show={(((ClientPortalHeader.InvoicePayment.EnableInvoicePayment &&
                                    ClientPortalHeader.InvoicePayment.IsBolSubmited) ||
                                    ClientPortalHeader.InvoicePayment.IsBilledJob) &&
                                    ClientPortalHeader.InvoicePayment.DueBalance > 0 &&
                                    ClientPortalHeader.InvoicePayment.HasPaymentGateway)}
                                ClassName="btn-right bg-brd"
                                Style={{
                                    background: buttoncolor.invoicepayment,
                                    color: calculateLuminance(buttoncolor.invoicepayment),
                                    border: `1px solid ${buttoncolor.invoicepayment}`
                                }}
                                For='PAY MY INVOICE'/>
                            {IsJobOpen ?
                                <></>
                                :
                                <div style={{
                                    background: buttoncolor.printestimate,
                                    color: calculateLuminance(buttoncolor.printestimate),
                                    border: `1px solid ${buttoncolor.printestimate}`
                                }}
                                     className="btn-right d-flex" onClick={() => printClientPortal()}>PRINT
                                    ESTIMATE</div>
                            }
                            {data.ShowSign && data.EventExist && Record.SignatureButtonShown ?
                                <Button Style={{
                                    background: buttoncolor.signestimate,
                                    color: calculateLuminance(buttoncolor.signestimate),
                                    border: `1px solid ${buttoncolor.signestimate}`
                                }}
                                        Show={!ClientPortalHeader.PortalSignature.IsSignaturePresent}
                                        ClsName="btn-right d-flex " For='SIGN ESTIMATE'/>
                                : <></>
                            }
                            {InvoiceType === "INVOICE_2" || InvoiceType === "INVOICE_1" ?
                                <div style={{
                                    background: buttoncolor.gotoinvoice,
                                    color: calculateLuminance(buttoncolor.gotoinvoice),
                                    border: `1px solid ${buttoncolor.gotoinvoice}`
                                }}
                                     className="btn-right d-flex" onClick={() => PageView.Set(InvoiceType)}> GO TO
                                    INVOICE</div> : ''}

                            <Modal show={Record.PaymentModal} onHide={() => handleModal()} className={
                                InputFields['billing_address'].show === true ? 'pay_deposit_modal2' :
                                    InputFields['zip_code'].show === true ? 'pay_deposit_modal3' : 'pay_deposit_modal'}
                                   style={{top: "10%"}}
                            >
                                <Modal.Header><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
                                    PAY DEPOSIT </h5>
                                    <button onClick={handleModal}
                                            style={{color: "red", background: "white", border: "white", height: "5%"}}>
                                        <b className="contactInfoCloseBtn">X</b></button>
                                </Modal.Header>
                                <Modal.Body id={
                                    InputFields['billing_address'].show === true ? 'pay_deposit_modal2' :
                                        InputFields['zip_code'].show === true ? 'pay_deposit_modal3' : 'pay_deposit_modal'}  style={{overflowY:"scroll"}}>
                                    <PayDepositForm/>
                                </Modal.Body>
                            </Modal>

                            <Modal show={Record.InvoicePaymentModal} onHide={() => hideInvoicePaymentModal()}
                                   style={{top: "10%"}}
                            >
                                <Modal.Header><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
                                    Invoice Payment </h5>
                                    <button onClick={() => hideInvoicePaymentModal()}
                                            style={{color: "red", background: "white", border: "white", height: "5%"}}>
                                        <b className="contactInfoCloseBtn">X</b></button>
                                </Modal.Header>
                                <Modal.Body id={
                                    InputFields['billing_address'].show === true ? 'pay_deposit_modal2' :
                                        InputFields['zip_code'].show === true ? 'pay_deposit_modal3' : 'pay_deposit_modal'} style={{overflowY:"scroll"}}>
                                    <InvoicePaymentForm FormatVisible={Record.FormatVisible} Tip={Record.Tip} />
                                </Modal.Body>
                            </Modal>

                            <TipModal/>

                            <Modal show={Record.SignModal} onHide={() => handleModal2()} className={
                                'sign_estimate_modal'}
                            >
                                <Modal.Header><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
                                    SIGN ESTIMATE </h5>
                                    <button onClick={handleModal2}
                                            style={{color: "red", background: "white", border: "white", height: "5%"}}>
                                        <b className="contactInfoCloseBtn">X</b></button>
                                </Modal.Header>
                                <Modal.Body> <SignaturePad/></Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};